// @ts-ignore
import Messenger from "messaging/messenger";
// @ts-ignore
import i18next from "i18n/i18n";
import type { Editor } from "ckeditor5";

export function getSelectedOrAllText(editor: Editor): { text: string; isSelection: boolean } {
  const selection = editor.model.document.selection;
  let selectedText = "";
  let isSelection = false;

  if (selection && !selection.isCollapsed) {
    const range = selection.getFirstRange();
    if (range) {
      for (const item of range.getItems()) {
        if (item.is("$text") || item.is("$textProxy")) {
          selectedText += item.data;
        }
      }
      isSelection = true;
    }
  }

  if (!selectedText) {
    selectedText = editor.getData();
  }

  return { text: selectedText, isSelection };
}

export async function removeFormattingConfirmation(): Promise<boolean> {
  return new Promise((resolve) => {
    Messenger.yesNoDialog(i18next.t("ai.warning.htmlTagsRemoved"), {
      yes: () => resolve(true),
      no: () => resolve(false),
    });
  });
}

export function replaceText(editor: Editor, newText: string, isSelection: boolean): void {
  editor.model.change((writer) => {
    const range = editor.model.document.selection.getFirstRange();
    const textNode = writer.createText(newText);
    if (isSelection && range) {
      // Replace selected text
      editor.model.insertContent(textNode, range);
    } else {
      // Replace all text safely
      const docRoot = editor.model.document.getRoot();
      if (!docRoot) return;
      writer.remove(writer.createRangeIn(docRoot));
      const position = writer.createPositionAt(docRoot, 0);
      editor.model.insertContent(textNode, position);
    }
  });
}

export function operationToCommand(operationName: string): string {
  const sanitizedName = operationName.replace(/\./g, "_");
  return `ResponseTransformation_${sanitizedName}_Command`;
}

export interface Operation {
  name: string;
  displayName: string;
}
